<template>
  <div class="job-teacher-page">
    <!-- 页面标题 + 学段选项卡 -->
    <div class="page-header">
      <div class="title-line">
        <span class="line"></span>
        <span class="title">学科组长</span>
      </div>

      <!-- 学段切换（核心改动） -->
      <el-tabs
        v-model="activeSection"
        @tab-click="handleSectionChange"
        class="section-tabs"
      >
        <el-tab-pane
          v-for="item in stageLists"
          :key="item.value"
          :label="item.label"
          :name="item.value"
        />
      </el-tabs>
    </div>

    <!-- 表格：只显示当前学段的学科 -->
    <div style="max-width: 80%;">
      <el-table
        :data="[{ label: '学科组长' }]"
        border
        style="width: 100%;"
        class="job-table"
      >
        <!-- 固定列 -->
        <el-table-column label="职务" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.label }}
          </template>
        </el-table-column>

        <!-- 动态学科列（根据学段变化） -->
        <el-table-column
          v-for="sub in subjectList.filter(v => v.value != 0)"
          :key="sub.value"
          :label="sub.label"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="teacher-btn"
              @click="openSetDialog(activeSection, sub.value)"
            >
              {{ getSectionSubjectTeacher(activeSection, sub.value) || '设置' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 设置学科组长弹窗 -->
    <el-dialog title="设置学科组长" :visible.sync="dialogVisible" width="550px" append-to-body="true"
		  	:loading="dialogLoading">
      <!-- 搜索选择教师 -->
      <el-select
        v-model="selectedTeacherId"
        placeholder="请选择教师"
        filterable
        remote
        :remote-method="searchTeacher"
        style="width: 100%; margin-bottom: 15px;"
        clearable
      >
        <el-option
          v-for="teacher in teacherList"
          :key="teacher.id"
          :label="teacher.name"
          :value="teacher.id"
        ></el-option>
      </el-select>

      <!-- 已选教师 -->
      <div v-if="selectedTeacherId" style="padding: 10px; background: #f7f8fa; border-radius: 6px;">
        已选教师：<b>{{ getSelectedName() }}</b>
        <el-button type="success" size="mini" @click="saveTeacher" style="margin-left: 10px;">
          确认保存
        </el-button>
      </div>

      <!-- 当前组长列表 -->
      <div style="margin-top: 15px;">
        <div style="font-weight: bold; margin-bottom: 8px;">当前学科组长：</div>
        <el-tag
          v-for="item in currentLeaderList"
          :key="item.id"
          type="primary"
          closable
          @close="deleteLeader(item.id)"
          style="margin-right: 8px; margin-bottom: 8px;"
        >
          {{ item.teacherName }}
        </el-tag>
        <div v-if="currentLeaderList.length === 0" style="color: #999;">暂无学科组长</div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { teacherSubject } from "@/js/standard.js";

export default {
  name: "JobTeacher",
  data() {
    return {
      subjectList: [],
      dialogVisible: false,
      teacherList: [],
      selectedTeacherId: null,
      schoolId: localStorage.getItem('orgId'),
      schoolInfo: {},
      currentLeaderList: [],
      currentSectionId: null,
      currentSubjectId: null,
      subjectLists: [],
      login: null,

      // 学段
      stageList: [
        { label: '小学', value: 1 },
        { label: '初中', value: 2 },
        { label: '高中', value: 3 }
      ],
	  stageLists:[],
      activeSection:'', // 当前选中学段
      sectionSubjectMap: {},
    };
  },
  computed: {
    // 过滤学校拥有的学段
  //   availableStages() {
		// console.log('this.schoolInfo',this.schoolInfo)
  //     if (!this.schoolInfo.stages) return []
  //     return this.stageList.filter(item =>
  //       this.schoolInfo.stages.includes(item.value.toString())
  //     )
  //   }
  },
  created() {
    this.forSubject();
    
  },
  methods: {
    loginOpen(text) {
      this.login = this.$loading({
        lock: true,
        text: text,
        zIndex: 100001,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    noLogin() {
      if (this.login) {
        this.login.close()
        this.login = null;
      }
    },

    // 学科
    async forSubject() {
      this.loginOpen('任职列表加载中...')
	  if(this.subjectLists.length==0){
		  this.subjectLists = await teacherSubject();
		  this.getSchoolInfo();
	  }else{
		  this.getSchoolInfo();
	  }
      
	  
    },

    // 加载学校信息
    getSchoolInfo() {
      this.API.get(this.API.school.getSchoolId + this.schoolId).then(res => {
        if (res.data.code == 200) {
          this.schoolInfo = res.data.data;
		  
		  this.stageLists=[]
		  for(let i=0;i<this.stageList.length;i++){
			  if(this.schoolInfo.stages.indexOf(this.stageList[i].value)>-1){
				  this.stageLists.push({...this.stageList[i]})
			  }
		  }
		  console.log('this.stageLists',this.stageLists)
		  if( this.stageLists.length>0){
			  this.activeSection=this.stageLists[0].value
			  this.handleSectionChange( this.stageLists[0].value) // 初始化加载当前学段
			  
		  }
          
        }
      }).catch(() => {
        this.noLogin()
      })
    },

    // 切换学段 → 刷新学科 + 刷新组长
    handleSectionChange() {
      this.subjectList = this.subjectLists?.filter(v => v.stageCode == this.activeSection) || []
      this.loadAllSectionLeaders()
    },

    // 加载当前学段所有学科组长（表格显示）
    loadAllSectionLeaders() {
      this.API.get(this.API.school.getSubjectList, {
        schoolId: this.schoolId,
        roleType: 6,
        sectionId: this.activeSection,
      }).then(res => {
        if (res.data.code === 200) {
          const list = res.data.data || [];
          const map = {};
          list.forEach(item => {
            const key = `${item.sectionId}_${item.subjectId}`;
            if (!map[key]) map[key] = [];
            if (!map[key].includes(item.teacherName)) {
              map[key].push(item.teacherName);
            }
          });

          const result = {};
          for (let k in map) {
            result[k] = map[k].join(' | ');
          }
          this.sectionSubjectMap = result;
        }
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    },

    // 表格显示教师
    getSectionSubjectTeacher(sectionId, subjectId) {
      const key = `${sectionId}_${subjectId}`;
      return this.sectionSubjectMap[key];
    },

    // 打开弹窗
    openSetDialog(sectionId, subjectId) {
      this.loginOpen('学科任职加载中...')
      this.currentSectionId = sectionId;
      this.currentSubjectId = subjectId;
      this.selectedTeacherId = null;

      this.API.get(this.API.school.getSubjectList, {
        schoolId: this.schoolId,
        roleType: 6,
        sectionId: sectionId,
        subjectId: subjectId
      }).then(res => {
        if (res.data.code == 200) {
          this.currentLeaderList = res.data.data;
          this.dialogVisible = true;
        }
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    },

    // 搜索教师
    searchTeacher(key) {
      this.loginOpen('教师列表查询中...')
      const name = key || '';
      this.API.get(this.API.school.getSchoolSearch, {
        pageNum: 1,
        pageSize: 100,
        schoolId: this.schoolId,
        name: name
      }).then(res => {
        this.teacherList = res.data.data.records;
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    },

    // 获取选中教师名
    getSelectedName() {
      const t = this.teacherList.find(u => u.id == this.selectedTeacherId);
      return t ? t.name : "";
    },

    // 保存
    saveTeacher() {
      if (!this.selectedTeacherId) {
        return this.$message.warning("请选择教师");
      }
      this.loginOpen('教师任职设置中...')
      const params = {
        userId: this.selectedTeacherId,
        schoolId: this.schoolId,
        roleType: 6,
        sectionId: this.currentSectionId,
        subjectId: this.currentSubjectId
      };

      this.API.post(this.API.school.postAssignSave, params).then(res => {
        if (res.data.code === 500) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success("设置成功");
          this.loadAllSectionLeaders();
          this.openSetDialog(this.currentSectionId, this.currentSubjectId);
          this.selectedTeacherId = null;
        }
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    },

    // 删除
    deleteLeader(id) {
      this.loginOpen('教师任职取消中...')
      this.API.deleted(this.API.school.deletedAssign + id).then(() => {
        this.$message.success("已取消任职");
        this.loadAllSectionLeaders();
        this.openSetDialog(this.currentSectionId, this.currentSubjectId);
        this.noLogin()
      }).catch(() => {
        this.noLogin()
      })
    }
  }
};
</script>

<style scoped>
.job-teacher-page {
	width: calc(60vw);
  padding: 15px;
}

.page-header {
  margin-bottom: 20px;
}

.title-line {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.line {
  display: inline-block;
  width: 3px;
  height: 16px;
  background-color: #1e88e5;
  margin-right: 8px;
}

.title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.section-tabs {
  margin-top: 10px;
}

.job-table /deep/ th {
  background-color: #1e88e5;
  color: #fff;
}

/deep/ .el-button--text {
  color: #1e88e5;
}

.teacher-btn {
  max-width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>